const formFieldsSoftware = [
  {
    key: 'name',
    label: 'IT Application',
    type: 'text',
    isRequired: true,
  },
  {
    key: 'impactedByLocalizedEvent',
    label: 'Impacted by Localized Event?',
    type: 'select',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  },
  {
    key: 'redundancyAvailable',
    label: 'Redundancy Available?',
    type: 'select',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  },
  {
    key: 'rampUpTime',
    label: 'Ramp-up / Failover Time',
    type: 'time',
    decoratorWord: 'hours',
  },
  { type: 'autocomplete' },
];

export { formFieldsSoftware };
